import { render, staticRenderFns } from "./SubscriptionHistories.vue?vue&type=template&id=07398ba6&scoped=true"
import script from "./SubscriptionHistories.vue?vue&type=script&lang=js"
export * from "./SubscriptionHistories.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07398ba6",
  null
  
)

export default component.exports